import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    ViewChild,
} from '@angular/core';
import { SewIcon } from '@sew/ui-components-angular/standalone';
import { SearchService } from './search.service';

@Component({
    selector: 'blog-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    imports: [CommonModule, SewIcon],
})
export class SearchComponent implements AfterViewInit, OnChanges {
    @Input() public focused = true;
    @Input() public query = '';
    @Input() public placeholder = '';

    @Output() public closeSearch = new EventEmitter();

    @ViewChild('searchQuery') public searchQuery!: ElementRef;

    public constructor(private search: SearchService) {}

    public ngAfterViewInit(): void {
        if (this.focused) {
            this.searchQuery.nativeElement.focus();
        }
        this.searchQuery.nativeElement.value = this.query;
    }

    public ngOnChanges(): void {
        if (this.searchQuery && this.searchQuery.nativeElement) {
            this.searchQuery.nativeElement.value = this.query;
        }
    }

    public onKeyUp(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.startSearch();
            event.preventDefault();
        }
        this.query = this.searchQuery.nativeElement.value;
        if (!this.query.length) {
            this.onCloseSearch();
        }
        if (this.query.length >= 3) {
            this.startSearch();
            event.preventDefault();
        }
    }

    public onCloseSearch(): void {
        this.closeSearch.emit();
    }

    private startSearch(): void {
        this.search.setSearchQuery(this.searchQuery.nativeElement.value);
    }
}
